import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormGroup,
  FormField,
  Dropdown
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'

const CardTrainingManagementUX = (props: any) => {
    return(
      <div
        style={{padding: "10px"}}>
        <Form
          className="small"
          id="CardEmployeeSummaryWorkHourUX-Form-1">
          <FormGroup
            id="CardEmployeeSummaryWorkHourUX-FormGroup-2"
            inline={true}>
            <FormField
              id="CardTrainingManagementUX-FormField-17"
              inline={true}
              width={4}>
              <label
                id="CardTrainingManagementUX-label-21"
                style={{minWidth: "max-content"}}>
                Division :
              </label>
              <Dropdown
                clearable={true}
                fluid={true}
                id="CardTrainingManagementUX-Dropdown-25"
                name="division_id"
                onChange={props.onChangeFilter}
                options={props.divisionOptions}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.filter?.division_id ?? ""}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardTrainingManagementUX-FormField-18"
              inline={true}
              width={4}>
              <label
                id="CardTrainingManagementUX-label-22"
                style={{minWidth: "max-content"}}>
                Search employee :
              </label>
              <div
                id="CardTrainingManagementUX-div-28"
                style={{width: "100%"}}>
                {props.employeeSearchBox}
              </div>
            </FormField>
            <FormField
              id="CardTrainingManagementUX-FormField-19"
              inline={true}
              width={4}>
              <label
                id="CardTrainingManagementUX-label-23"
                style={{minWidth: "max-content"}}>
                Search course :
              </label>
              <div
                id="CardTrainingManagementUX-div-27"
                style={{width: "100%"}}>
                {props.courseSearchBox}
              </div>
            </FormField>
            <FormField
              id="CardTrainingManagementUX-FormField-20"
              inline={true}
              width={4}>
              <label
                id="CardTrainingManagementUX-label-24"
                style={{minWidth: "max-content"}}>
                Type :
              </label>
              <Dropdown
                clearable={true}
                fluid={true}
                id="CardTrainingManagementUX-Dropdown-26"
                name="training_type"
                onChange={props.onChangeFilter}
                options={props.typeOptions}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.filter?.training_type?? ""}>
              </Dropdown>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardTrainingManagementUX-FormGroup-16"
            inline={true}>
            <FormField
              id="CardTrainingManagementUX-FormField-29"
              inline={true}
              width={4}>
              <label
                id="CardTrainingManagementUX-label-32"
                style={{minWidth: "max-content"}}>
                Course start from :
              </label>
              <div
                id="CardTrainingManagementUX-div-35"
                style={{width: "100%"}}>

                <DateTextBox
                  id="CardTrainingManagementUX-DateTextBox-40"
                  onChange={(value: any)=>props.onChangeFilter?.(null, {name: "course_start_date_from", value})}
                  value={props.filter?.course_start_date_from}>
                </DateTextBox>
              </div>
            </FormField>
            <FormField
              id="CardTrainingManagementUX-FormField-30"
              inline={true}
              width={4}>
              <label
                id="CardTrainingManagementUX-label-33"
                style={{minWidth: "max-content"}}>
                to
              </label>
              <div
                id="CardTrainingManagementUX-div-36"
                style={{width: "100%"}}>

                <DateTextBox
                  id="CardTrainingManagementUX-DateTextBox-41"
                  onChange={(value: any)=>props.onChangeFilter?.(null, {name: "course_start_date_to", value})}
                  value={props.filter?.course_start_date_to}>
                </DateTextBox>
              </div>
            </FormField>
            <FormField
              id="CardTrainingManagementUX-FormField-31"
              inline={true}
              width={4}>
              <label
                id="CardTrainingManagementUX-label-34"
                style={{minWidth: "max-content"}}>
                Status :
              </label>
              <Dropdown
                clearable={true}
                fluid={true}
                id="CardTrainingManagementUX-Dropdown-37"
                name="attendance_status"
                onChange={props.onChangeFilter}
                options={props.statusOptions}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.filter?.attendance_status?? ""}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardTrainingManagementUX-FormField-38">
              <div
                id="CardTrainingManagementUX-div-39">
                {props.buttonSearch}
              </div>
            </FormField>
          </FormGroup>
        </Form>
        <div
          id="CardEmployeeSummaryWorkHourUX-div-15"
          style={{width: "100%"}}>
          {}
        </div>
      </div>
    )
}


export default CardTrainingManagementUX

export const screenPropsDefault = {"cannotPay":false,"cashAmountText":"14","citizenID":"31020000552","oweText":123,"patientNameAndHN":"HN: xxxxx นายทดสอบ","sumAmount":{"price":100,"reimbursable":42}}

/* Date Time : Thu Jul 24 2025 09:51:08 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": "semantic-ui-react",
      "id": 1,
      "name": "Form",
      "parent": 0,
      "props": {
        "className": {
          "type": "value",
          "value": "small"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-Form-1"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 2,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-FormGroup-2"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-div-15"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 16,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTrainingManagementUX-FormGroup-16"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 17,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTrainingManagementUX-FormField-17"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 18,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTrainingManagementUX-FormField-18"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 19,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTrainingManagementUX-FormField-19"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 20,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTrainingManagementUX-FormField-20"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": null,
      "id": 21,
      "name": "label",
      "parent": 17,
      "props": {
        "children": {
          "type": "value",
          "value": "Division : "
        },
        "id": {
          "type": "value",
          "value": "CardTrainingManagementUX-label-21"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": null,
      "id": 22,
      "name": "label",
      "parent": 18,
      "props": {
        "children": {
          "type": "value",
          "value": "Search employee : "
        },
        "id": {
          "type": "value",
          "value": "CardTrainingManagementUX-label-22"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": null,
      "id": 23,
      "name": "label",
      "parent": 19,
      "props": {
        "children": {
          "type": "value",
          "value": "Search course : "
        },
        "id": {
          "type": "value",
          "value": "CardTrainingManagementUX-label-23"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": null,
      "id": 24,
      "name": "label",
      "parent": 20,
      "props": {
        "children": {
          "type": "value",
          "value": "Type : "
        },
        "id": {
          "type": "value",
          "value": "CardTrainingManagementUX-label-24"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 25,
      "name": "Dropdown",
      "parent": 17,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardTrainingManagementUX-Dropdown-25"
        },
        "name": {
          "type": "value",
          "value": "division_id"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "options": {
          "type": "code",
          "value": "props.divisionOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filter?.division_id ?? \"\""
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 26,
      "name": "Dropdown",
      "parent": 20,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardTrainingManagementUX-Dropdown-26"
        },
        "name": {
          "type": "value",
          "value": "training_type"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "options": {
          "type": "code",
          "value": "props.typeOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filter?.training_type?? \"\""
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": null,
      "id": 27,
      "name": "div",
      "parent": 19,
      "props": {
        "children": {
          "type": "code",
          "value": "props.courseSearchBox"
        },
        "id": {
          "type": "value",
          "value": "CardTrainingManagementUX-div-27"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": null,
      "id": 28,
      "name": "div",
      "parent": 18,
      "props": {
        "children": {
          "type": "code",
          "value": "props.employeeSearchBox"
        },
        "id": {
          "type": "value",
          "value": "CardTrainingManagementUX-div-28"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 29,
      "name": "FormField",
      "parent": 16,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTrainingManagementUX-FormField-29"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 30,
      "name": "FormField",
      "parent": 16,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTrainingManagementUX-FormField-30"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 31,
      "name": "FormField",
      "parent": 16,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTrainingManagementUX-FormField-31"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": null,
      "id": 32,
      "name": "label",
      "parent": 29,
      "props": {
        "children": {
          "type": "value",
          "value": "Course start from : "
        },
        "id": {
          "type": "value",
          "value": "CardTrainingManagementUX-label-32"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": null,
      "id": 33,
      "name": "label",
      "parent": 30,
      "props": {
        "children": {
          "type": "value",
          "value": "to"
        },
        "id": {
          "type": "value",
          "value": "CardTrainingManagementUX-label-33"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": null,
      "id": 34,
      "name": "label",
      "parent": 31,
      "props": {
        "children": {
          "type": "value",
          "value": "Status : "
        },
        "id": {
          "type": "value",
          "value": "CardTrainingManagementUX-label-34"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": null,
      "id": 35,
      "name": "div",
      "parent": 29,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTrainingManagementUX-div-35"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": null,
      "id": 36,
      "name": "div",
      "parent": 30,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTrainingManagementUX-div-36"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 37,
      "name": "Dropdown",
      "parent": 31,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardTrainingManagementUX-Dropdown-37"
        },
        "name": {
          "type": "value",
          "value": "attendance_status"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "options": {
          "type": "code",
          "value": "props.statusOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filter?.attendance_status?? \"\""
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 38,
      "name": "FormField",
      "parent": 16,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTrainingManagementUX-FormField-38"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": null,
      "id": 39,
      "name": "div",
      "parent": 38,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSearch"
        },
        "id": {
          "type": "value",
          "value": "CardTrainingManagementUX-div-39"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 40,
      "name": "DateTextBox",
      "parent": 35,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTrainingManagementUX-DateTextBox-40"
        },
        "onChange": {
          "type": "code",
          "value": "(value: any)=>props.onChangeFilter?.(null, {name: \"course_start_date_from\", value})"
        },
        "value": {
          "type": "code",
          "value": "props.filter?.course_start_date_from"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 41,
      "name": "DateTextBox",
      "parent": 36,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTrainingManagementUX-DateTextBox-41"
        },
        "onChange": {
          "type": "code",
          "value": "(value: any)=>props.onChangeFilter?.(null, {name: \"course_start_date_to\", value})"
        },
        "value": {
          "type": "code",
          "value": "props.filter?.course_start_date_to"
        }
      },
      "seq": 41,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardTrainingManagementUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "cannotPay": false,
    "cashAmountText": "14",
    "citizenID": "31020000552",
    "oweText": 123,
    "patientNameAndHN": "HN: xxxxx นายทดสอบ",
    "sumAmount": {
      "price": 100,
      "reimbursable": 42
    }
  },
  "width": 75
}

*********************************************************************************** */
